import {css, StyleSheet} from 'aphrodite';
import Backbone from 'backbone';
import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import ComplexPolymerMap from 'modbio/complex-polymers/tabs/ComplexPolymerMap';
import ComplexPolymerMapTabState from 'modbio/complex-polymers/tabs/ComplexPolymerMapTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export interface ComplexPolymerMapTabProps {
  complexPolymerId: string;
  isEditable: boolean;
}

function ComplexPolymerMapTab(props: ComplexPolymerMapTabProps): JSX.Element {
  return (
    <div className={classNames('react-tab-container', css(styles.dragAndDropCanvas))}>
      <ComplexPolymerMap {...props} />
    </div>
  );
}

export default class ComplexPolymerMapTabView extends BufferTabView<ComplexPolymerMapTabState> {
  override render(): this {
    const props = {
      complexPolymerId: this.model.get('complexPolymerId'),
      isEditable: this.model.get('isEditable'),
    };
    renderToDOM(<ComplexPolymerMapTab {...props} />, this.el);
    return this;
  }

  override remove(): Backbone.View<ComplexPolymerMapTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ComplexPolymerMapTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';

const styles = StyleSheet.create({
  tabPadding: {
    paddingBottom: 0,
  },
  dragAndDropCanvas: {
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
